define (require) ->


  PIXI.DisplayObject::bringToFront = ->
    if @parent
      parent = @parent
      parent.removeChild this
      parent.addChild this
    return

  #--------------

  PIXI.DisplayObject::zSort = ->
    result = @children.sort (a,b) ->
      return -1 if (a.z < b.z)
      return 1 if (a.z > b.z)
      return 0

    @children = result

  #--------------

  PIXI.DisplayObject::getByTag = (tag) ->
    return null if not @children?.length? or not @children.length

    objects = []

    for child in @children
      objects.push child if child.tag is tag

    if objects.length > 1
      return objects

    if objects.length is 1
      return objects[0]

    return null

  #--------------

  PIXI.DisplayObject::removeAllChildren = ->
    while @children[0]
      @children[0].removeChildren()
      @removeChild @children[0]
    return

  #--------------

  PIXI.DisplayObject::removeSelf = ->
    @parent.removeChild @

  #--------------

  PIXI.Container::centerX = (width) ->
    width = @parent.width unless width?
    @position.x = Math.floor (width-@width)/2

  #--------------

  PIXI.Container::centerY = (height) ->
    height = @parent.height unless height?
    @position.y = Math.floor (height-@height)/2

  #--------------

  PIXI.Container::centerAtPoint = (x,y) ->

    @x = Math.round(x - (@width/2)) + 1
    @y = Math.round(y - (@height/2))

  #--------------

  PIXI.Text::clarify = (dpi = __dpi) ->
    @resolution = dpi
    @updateText()

  #--------------

  PIXI.Text::sizeToFit = (width, scaleUp = true) ->

    w = @width
    h = @height

    # if @width > width
    while @width > width
      @style.fontSize--

    # if @width < width and scaleUp
    #   while @width < width
    #     @style.fontSize++

    # if height and @height > height
    #   scale = @height/height
    #   @scale.set(scale)

    ratio = @width/w
    change = h - @height*ratio
    @style.lineHeight -= change


// WEBPACK FOOTER //
// ./coffee/extender/pixi-extender.coffee